import {ConfigurationForm} from './configurationForm';

export class DuplicateScheduleForm {
  configurationToDuplicateId: string;
  configurationForm: ConfigurationForm;

  constructor(configurationToDuplicateId: string, configurationForm: ConfigurationForm) {
    this.configurationToDuplicateId = configurationToDuplicateId;
    this.configurationForm = configurationForm;
  }
}
